import { useStatsOrdersOverviewCurrent } from "../../api/hooks/stats";

const monthNames = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

const CurrentOrders = () => {
  const { data } = useStatsOrdersOverviewCurrent();
  return (
    <div className="flex w-1/2 flex-col gap-4 rounded-xl border-2 pb-4">
      <div className="flex gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-1 text-lg">
        <div>Current Orders</div>
      </div>
      <div className="flex flex-col gap-4 divide-y px-6">
        <div className="flex gap-6 px-6 pt-6">
          <div className="flex w-5 items-center justify-center">
            <p className="-rotate-90 text-nowrap text-center text-lg font-bold"></p>
          </div>
          <div className="flex flex-grow flex-col gap-4 divide-y">
            <div className="flex justify-around gap-6 px-6">
              <div className="text-center">
                <p className="">Pending Approval</p>
                <p className="text-lg font-bold">
                  {data?.approvals?.count || 0}
                </p>
                <p className="">{data?.approvals?.quantity || 0} Qty</p>
              </div>
              <div className="text-center">
                <p className="">Shortfalls</p>
                <p className="text-lg font-bold">
                  {data?.shortfalls?.count || 0}
                </p>
                <p className="">{data?.shortfalls?.quantity || 0} Qty</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-6 divide-x px-6 pt-6">
          <div className="flex w-5 items-center justify-center">
            <p className="-rotate-90 text-nowrap text-center text-lg font-bold">
              {monthNames[(data?.month || 1) - 1]}
            </p>
          </div>
          <div className="flex flex-grow flex-col gap-6 divide-y pl-6">
            <div className="flex justify-around gap-6">
              <div className="text-center">
                <p className="">Orders</p>
                <p className="text-lg font-bold">{data?.orders?.count || 0}</p>
                <p className="">{data?.orders?.quantity || 0} Qty</p>
              </div>
              <div className="text-center">
                <p className="">Fulfillment</p>
                <p className="text-lg font-bold">
                  {data?.fulfillment?.count || 0}
                </p>
                <p className="">{data?.fulfillment?.quantity || 0} Qty</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentOrders;
